import { Popover } from '@mui/material';
import { FC } from 'react';
import { MenuList, MenuListProps } from '.';

type Props = MenuListProps & {
  anchor: HTMLElement | null | undefined;
  closeMenu: () => void;
};

export type PopoverMenuListProps = Props;

export const PopoverMenuList: FC<Props> = ({ config, anchor, closeMenu }) => {
  return (
    <Popover
      open={Boolean(anchor)}
      anchorEl={anchor}
      onClose={closeMenu}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
      BackdropProps={{
        invisible: true,
        style: { backgroundColor: 'transparent', opacity: '0' }
      }}
      PaperProps={{
        className: 'shadow-500'
      }}
    >
      <MenuList config={config} closeMenu={closeMenu} />
    </Popover>
  );
};
